import { FilterModel } from "../../../shared/filter/models"

export const ChangeFilters = (filters: FilterModel[]) => {
    return {
        type: 'change_filters',
        payload: filters
    }
}